import { render, staticRenderFns } from "./fl44-notices-list.vue?vue&type=template&id=210ff988&scoped=true&"
import script from "./fl44-notices-list.vue?vue&type=script&lang=js&"
export * from "./fl44-notices-list.vue?vue&type=script&lang=js&"
import style0 from "./fl44-notices-list.vue?vue&type=style&index=0&id=210ff988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ff988",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('210ff988')) {
      api.createRecord('210ff988', component.options)
    } else {
      api.reload('210ff988', component.options)
    }
    module.hot.accept("./fl44-notices-list.vue?vue&type=template&id=210ff988&scoped=true&", function () {
      api.rerender('210ff988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/fl44-notices/fl44-notices-list.vue"
export default component.exports